import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 80 } }

  connect() {
    const html = this.element.innerHTML.trim()
    const words = html.split(/(\s+|<[^>]+>)/).filter(w => w.length > 0)

    let wordIndex = 0
    this.element.innerHTML = words.map(word => {
      if (word.match(/^</) || word.match(/^\s+$/)) return word

      const span = `<span class="inline-block" style="opacity:0;transform:translateY(12px);transition:opacity 0.5s ease ${wordIndex * this.delayValue}ms, transform 0.5s ease ${wordIndex * this.delayValue}ms">${word}</span>`
      wordIndex++
      return span
    }).join(" ")

    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.element.querySelectorAll("span[style]").forEach(s => {
          s.style.opacity = "1"
          s.style.transform = "none"
        })
        this.observer.disconnect()
      }
    }, { threshold: 0.3 })
    this.observer.observe(this.element)
  }
}
